const playButton = document.querySelector(".hero-global .play");
const video = document.querySelector(".hero-global .video video");

if (playButton && video) {
  playButton.addEventListener("click", () => {
    if (video.paused) {
      video.play();
      playButton.classList.remove("active");
    } else {
      video.pause();
      playButton.classList.add("active");
    }
  });
}
